<template>
  <SettingsPageLayout>
    <DetailForm
      v-if="loaded"
      class="mt-6"
      title="Calendar"
      description="Share your availabilty based on your calendar. For help connecting your calendar, email support@humaniz.io."
      action="Save"
      hidecancel="true"
      @handle-action="updateUser"
    >
      <ul class="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <li class="col-span-1">
          <div class="border border-gray-200 rounded-full">
            <div class="-mt-px flex">
              <div v-if="!currentUserCalendar.isGoogleAuthenticated" class="w-0 flex-1 flex">
                <form
                  :action="`/users/auth/google?prompt=consent&login_hint=${$store.state.general.currentUserAccountDetails.username}`"
                  method="post"
                  class="cursor-pointer relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-full hover:text-gray-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 focus:z-10 transition ease-in-out duration-150"
                >
                  <svg
                    id="Livello_1"
                    class="h-6 w-6 mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 200 200"
                    enable-background="new 0 0 200 200"
                    xml:space="preserve"
                  >
                    <g>
                      <g transform="translate(3.75 3.75)">
                        <path
                          fill="#FFFFFF"
                          d="M148.882,43.618l-47.368-5.263l-57.895,5.263L38.355,96.25l5.263,52.632l52.632,6.579l52.632-6.579    l5.263-53.947L148.882,43.618z"
                        />
                        <path
                          fill="#1A73E8"
                          d="M65.211,125.276c-3.934-2.658-6.658-6.539-8.145-11.671l9.132-3.763c0.829,3.158,2.276,5.605,4.342,7.342    c2.053,1.737,4.553,2.592,7.474,2.592c2.987,0,5.553-0.908,7.697-2.724s3.224-4.132,3.224-6.934c0-2.868-1.132-5.211-3.395-7.026    s-5.105-2.724-8.5-2.724h-5.276v-9.039H76.5c2.921,0,5.382-0.789,7.382-2.368c2-1.579,3-3.737,3-6.487    c0-2.447-0.895-4.395-2.684-5.855s-4.053-2.197-6.803-2.197c-2.684,0-4.816,0.711-6.395,2.145s-2.724,3.197-3.447,5.276    l-9.039-3.763c1.197-3.395,3.395-6.395,6.618-8.987c3.224-2.592,7.342-3.895,12.342-3.895c3.697,0,7.026,0.711,9.974,2.145    c2.947,1.434,5.263,3.421,6.934,5.947c1.671,2.539,2.5,5.382,2.5,8.539c0,3.224-0.776,5.947-2.329,8.184    c-1.553,2.237-3.461,3.947-5.724,5.145v0.539c2.987,1.25,5.421,3.158,7.342,5.724c1.908,2.566,2.868,5.632,2.868,9.211    s-0.908,6.776-2.724,9.579c-1.816,2.803-4.329,5.013-7.513,6.618c-3.197,1.605-6.789,2.421-10.776,2.421    C73.408,129.263,69.145,127.934,65.211,125.276z"
                        />
                        <path
                          fill="#1A73E8"
                          d="M121.25,79.961l-9.974,7.25l-5.013-7.605l17.987-12.974h6.895v61.197h-9.895L121.25,79.961z"
                        />
                        <path
                          fill="#EA4335"
                          d="M148.882,196.25l47.368-47.368l-23.684-10.526l-23.684,10.526l-10.526,23.684L148.882,196.25z"
                        />
                        <path fill="#34A853" d="M33.092,172.566l10.526,23.684h105.263v-47.368H43.618L33.092,172.566z" />
                        <path
                          fill="#4285F4"
                          d="M12.039-3.75C3.316-3.75-3.75,3.316-3.75,12.039v136.842l23.684,10.526l23.684-10.526V43.618h105.263    l10.526-23.684L148.882-3.75H12.039z"
                        />
                        <path
                          fill="#188038"
                          d="M-3.75,148.882v31.579c0,8.724,7.066,15.789,15.789,15.789h31.579v-47.368H-3.75z"
                        />
                        <path fill="#FBBC04" d="M148.882,43.618v105.263h47.368V43.618l-23.684-10.526L148.882,43.618z" />
                        <path
                          fill="#1967D2"
                          d="M196.25,43.618V12.039c0-8.724-7.066-15.789-15.789-15.789h-31.579v47.368H196.25z"
                        />
                      </g>
                    </g>
                  </svg>
                  <input type="hidden" name="authenticity_token" :value="csrf" />
                  <button type="submit">Connect Google Calendar</button>
                </form>
              </div>
              <div v-else class="-ml-px w-0 flex-1 flex">
                <div
                  class="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-full hover:text-gray-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 focus:z-10 transition ease-in-out duration-150"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    class="mr-2 text-green-400 w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"
                    />
                  </svg>
                  <span class="ml-3">Google Calendar Connected</span>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li class="col-span-1">
          <div class="border border-gray-200 rounded-full">
            <div class="-mt-px flex">
              <div v-if="!currentUserCalendar.isMicrosoftAuthenticated" class="w-0 flex-1 flex">
                <form
                  :action="`/users/auth/microsoft?prompt=consent&login_hint=${$store.state.general.currentUserAccountDetails.username}`"
                  method="post"
                  class="cursor-pointer relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-full hover:text-gray-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 focus:z-10 transition ease-in-out duration-150"
                >
                  <svg
                    class="w-6 h-6 mr-2"
                    viewBox="0 0 256 256"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid"
                  >
                    <title>Microsoft</title>
                    <g>
                      <polygon fill="#F1511B" points="121.666095 121.666095 0 121.666095 0 0 121.666095 0"></polygon>
                      <polygon
                        fill="#80CC28"
                        points="256 121.666095 134.335356 121.666095 134.335356 0 256 0"
                      ></polygon>
                      <polygon
                        fill="#00ADEF"
                        points="121.663194 256.002188 0 256.002188 0 134.336095 121.663194 134.336095"
                      ></polygon>
                      <polygon
                        fill="#FBBC09"
                        points="256 256.002188 134.335356 256.002188 134.335356 134.336095 256 134.336095"
                      ></polygon>
                    </g>
                  </svg>
                  <input type="hidden" name="authenticity_token" :value="csrf" />
                  <button type="submit">Connect Microsoft Calendar</button>
                </form>
              </div>
              <div v-else class="-ml-px w-0 flex-1 flex">
                <div
                  class="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-full hover:text-gray-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 focus:z-10 transition ease-in-out duration-150"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    class="mr-2 text-green-400 w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"
                    />
                  </svg>
                  <span class="ml-3">Microsoft Calendar Connected</span>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <SelectMenu
        label="Timezone"
        :options="timezones"
        :initial-value="user?.timezone"
        @selected-option="user.timezone = $event"
      />
      <SelectMenu
        label="Event Buffer"
        :options="eventBuffer"
        :initial-value="user.eventBuffer"
        @selected-option="user.eventBuffer = $event"
      />
      <p class="block text-sm leading-5 font-medium text-gray-700 mb-4">Event Availability</p>
      <div class="grid grid-cols-3 gap-x-6 gap-y-8 mb-4">
        <CheckboxInput
          class="mt-2 flex items-center"
          description="Sunday"
          :model-value="availability.sunday.isAvailable"
          @update:model-value="availability.sunday.isAvailable = $event"
        />
        <TimeInput
          :model-value="availability.sunday.startTime"
          @update:model-value="availability.sunday.startTime = $event"
        />
        <TimeInput
          :model-value="availability.sunday.endTime"
          @update:model-value="availability.sunday.endTime = $event"
        />
      </div>
      <div class="grid grid-cols-3 gap-x-6 gap-y-8 mb-4">
        <CheckboxInput
          class="mt-2 flex items-center"
          description="Monday"
          :model-value="availability.monday.isAvailable"
          @update:model-value="availability.monday.isAvailable = $event"
        />
        <TimeInput
          :model-value="availability.monday.startTime"
          @update:model-value="availability.monday.startTime = $event"
        />
        <TimeInput
          :model-value="availability.monday.endTime"
          @update:model-value="availability.monday.endTime = $event"
        />
      </div>
      <div class="grid grid-cols-3 gap-x-6 gap-y-8 mb-4">
        <CheckboxInput
          class="mt-2 flex items-center"
          description="Tuesday"
          :model-value="availability.tuesday.isAvailable"
          @update:model-value="availability.tuesday.isAvailable = $event"
        />
        <TimeInput
          :model-value="availability.tuesday.startTime"
          @update:model-value="availability.tuesday.startTime = $event"
        />
        <TimeInput
          :model-value="availability.tuesday.endTime"
          @update:model-value="availability.tuesday.endTime = $event"
        />
      </div>
      <div class="grid grid-cols-3 gap-x-6 gap-y-8 mb-4">
        <CheckboxInput
          class="mt-2 flex items-center"
          description="Wednesday"
          :model-value="availability.wednesday.isAvailable"
          @update:model-value="availability.wednesday.isAvailable = $event"
        />
        <TimeInput
          :model-value="availability.wednesday.startTime"
          @update:model-value="availability.wednesday.startTime = $event"
        />
        <TimeInput
          :model-value="availability.wednesday.endTime"
          @update:model-value="availability.wednesday.endTime = $event"
        />
      </div>
      <div class="grid grid-cols-3 gap-x-6 gap-y-8 mb-4">
        <CheckboxInput
          class="mt-2 flex items-center"
          description="Thursday"
          :model-value="availability.thursday.isAvailable"
          @update:model-value="availability.thursday.isAvailable = $event"
        />
        <TimeInput
          :model-value="availability.thursday.startTime"
          @update:model-value="availability.thursday.startTime = $event"
        />
        <TimeInput
          :model-value="availability.thursday.endTime"
          @update:model-value="availability.thursday.endTime = $event"
        />
      </div>
      <div class="grid grid-cols-3 gap-x-6 gap-y-8 mb-4">
        <CheckboxInput
          class="mt-2 flex items-center"
          description="Friday"
          :model-value="availability.friday.isAvailable"
          @update:model-value="availability.friday.isAvailable = $event"
        />
        <TimeInput
          :model-value="availability.friday.startTime"
          @update:model-value="availability.friday.startTime = $event"
        />
        <TimeInput
          :model-value="availability.friday.endTime"
          @update:model-value="availability.friday.endTime = $event"
        />
      </div>
      <div class="grid grid-cols-3 gap-x-6 gap-y-8">
        <CheckboxInput
          class="mt-2 flex items-center"
          description="Saturday"
          :model-value="availability.saturday.isAvailable"
          @update:model-value="availability.saturday.isAvailable = $event"
        />
        <TimeInput
          :model-value="availability.saturday.startTime"
          @update:model-value="availability.saturday.startTime = $event"
        />
        <TimeInput
          :model-value="availability.saturday.endTime"
          @update:model-value="availability.saturday.endTime = $event"
        />
      </div>
    </DetailForm>
  </SettingsPageLayout>
</template>

<script>
import { mapState } from 'vuex';
import SettingsPageLayout from '../../SettingsPageLayout/index.vue';
import RailsUtility from '../../../utilities/rails.ts';
import DetailForm from '../../shared/DetailForm.vue';
import TimeInput from '../../shared/TimeInput.vue';
import CheckboxInput from '../../shared/CheckboxInput.vue';
import SelectMenu from '../../shared/SelectMenu.vue';
import { getUserCalendarAuthStatus } from '../../../api/users.ts';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
    TimeInput,
    CheckboxInput,
    SelectMenu,
  },
  data() {
    return {
      availability: this.currentUserAvailability,
      timezones: [
        'Hawaii',
        'Alaska',
        'Pacific Time (US & Canada)',
        'Arizona',
        'Mountain Time (US & Canada)',
        'Central Time (US & Canada)',
        'Eastern Time (US & Canada)',
      ],
      eventBuffer: ['1 hours', '2 hours', '3 hours', '4 hours', '8 hours', '12 hours', '24 hours'],
      loaded: false,
    };
  },
  computed: {
    ...mapState({
      user: state => state.general.currentUser,
      currentUserAvailability: state => state.general.currentUserAvailability,
      currentUserCalendar: state => state.general.currentUserCalendar,
    }),
    csrf() {
      return document.querySelectorAll('[name="csrf-token"]')[0].content;
    },
  },
  async mounted() {
    await this.getUser();
  },
  methods: {
    async getUser() {
      await this.$store.dispatch('general/loadCurrentUser');
      this.availability = { ...this.currentUserAvailability };
      await this.getCalendarConnection();
    },
    async getCalendarConnection() {
      this.$store.commit('general/showLoadingSpinner');
      const data = await getUserCalendarAuthStatus(this.user);
      this.$store.commit('general/setCurrentUserCalendar', {
        isGoogleAuthenticated: data.is_google_authenticated,
        isMicrosoftAuthenticated: data.is_microsoft_authenticated,
      });
      this.$store.commit('general/hideLoadingSpinner');
      this.loaded = true;
    },
    updateUser() {
      const self = this;
      self.$store.commit('general/showLocalLoadingSpinner');

      // Convert the availability object to the format expected by the server
      const availabilityArray = Object.entries(self.availability).map(([dayOfWeek, dayData]) => ({
        day_of_week: dayOfWeek,
        start_time: dayData.startTime,
        end_time: dayData.endTime,
        is_available: dayData.isAvailable,
      }));

      fetch(`/api/user_calendars/${self.user?.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          timezone: self.user.timezone,
          event_buffer: RailsUtility.convertToEnumFormat(self.user.eventBuffer),
          availability: availabilityArray.reduce((acc, curr) => {
            acc[curr.day_of_week] = {
              startTime: curr.start_time,
              endTime: curr.end_time,
              isAvailable: curr.is_available,
            };
            return acc;
          }, {}),
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            // First, update the store with the new availability directly
            self.$store.commit('general/setCurrentUserAvailability', {
              availability: availabilityArray,
            });

            // Also update timezone and event buffer in the store
            self.$store.commit('general/setCurrentUser', {
              currentUser: self.user,
              timezone: self.user.timezone,
              teamSlug: self.user.teamSlug,
              eventBuffer: self.user.eventBuffer,
            });

            // Then reload the user data to ensure everything is in sync
            self.$store.dispatch('general/loadCurrentUser');

            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Calendar updated',
              alertDescription: 'Your Calendar was successfully updated. Use the button below to dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Calendar update error',
              alertDescription: data.message,
            });
          }
        })
        .catch(error => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          self.$store.commit('general/showAlert', {
            alertType: 'error',
            alertTitle: 'Calendar update error',
            alertDescription: 'An error occurred while updating your calendar settings.',
          });
          console.error('Calendar update error:', error);
        });
    },
  },
};
</script>
